import { ApiResponse } from "src/shared/types";
import appFetch from "src/shared/fetch";
import { getXClientIdHeader } from "src/utils/getservicename";
import { devLogging } from "./logger";

interface Restaurant {
  restaurant_id: string;
  restaurant_name: string;
}

// Cache variables that persist for the session
let cachedRestaurants: Restaurant[] = [];
let cachedPocs: string[] = [];
let cachedL1Managers: string[] = [];
let hasLoadedRestaurants = false;
let hasLoadedPocs = false;
let hasLoadedL1Managers = false;

export const fetchRestaurantData = async (): Promise<Restaurant[]> => {
  try {
    // Return cached data if available
    if (hasLoadedRestaurants) {
      devLogging("fetchRestaurantData", "Returning cached data");
      return cachedRestaurants;
    }

    const { response, error } = await appFetch.get("/api/anobis/restaurant/", {
      headers: {
        ...getXClientIdHeader(),
        "X-Clear-Cache": "true",
      },
    });

    if (error) {
      console.error("Error fetching restaurant data:", error);
      return [];
    }

    // Store response in cache
    cachedRestaurants = response || [];
    hasLoadedRestaurants = true;
    return cachedRestaurants;
  } catch (err) {
    console.error("Failed to fetch restaurant data:", err);
    return [];
  }
};

// Add new function to fetch POC data
export const fetchPocData = async (): Promise<string[]> => {
  try {
    // Return cached data if available
    if (hasLoadedPocs) {
      devLogging("fetchPocData", "Returning cached data");
      return cachedPocs;
    }

    const { response, error } = await appFetch.get("/api/anobis/restaurant/pocs", {
      headers: {
        ...getXClientIdHeader(),
        "X-Clear-Cache": "true",
      },
    });

    if (error) {
      console.error("Error fetching POC data:", error);
      return [];
    }

    // Store response in cache
    cachedPocs = response || [];
    hasLoadedPocs = true;
    return cachedPocs;
  } catch (err) {
    console.error("Failed to fetch POC data:", err);
    return [];
  }
};

export const fetchL1ManagerData = async (): Promise<string[]> => {
  try {
    // Return cached data if available
    if (hasLoadedL1Managers) {
      devLogging("fetchL1ManagerData", "Returning cached data");
      return cachedL1Managers;
    }

    const { response, error } = await appFetch.get("/api/anobis/restaurant/l1-managers", {
      headers: {
        ...getXClientIdHeader(),
        "X-Clear-Cache": "true",
      },
    });

    if (error) {
      console.error("Error fetching L1 manager data:", error);
      return [];
    }
    
    // Store response in cache
    cachedL1Managers = response || [];
    hasLoadedL1Managers = true;
    return cachedL1Managers;
  } catch (err) {
    console.error("Failed to fetch L1 manager data:", err);
    return [];
  }
};

// Optional: Add a function to clear the cache if needed
export const clearCache = (): void => {
  cachedRestaurants = [];
  cachedPocs = [];
  cachedL1Managers = [];
  hasLoadedRestaurants = false;
  hasLoadedPocs = false;
  hasLoadedL1Managers = false;
};
